/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import * as blogActions from '../../actions/blogActions';
import Loading from '../common/Loading';
import ShareService from '../../services/shareService.js';
import urls from '../../constants/urls.js';
import articleTypes from '../../constants/articleTypes';
import ContentShare from '../common/ContentShare';
import Advert from '../common/Advert';
import NotFound from '../common/NotFound';
import startsWith from 'lodash/startsWith';

class ArticlePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.getArticle = this.getArticle.bind(this);
        this.getImageShareUrl = this.getImageShareUrl.bind(this);
    }

    componentWillMount() {        
        this.getArticle();
    }

    componentDidMount() {       
        this.addEmbedClick();
    }

    componentDidUpdate(prevProps, prevState) {
        
        if(this.props.match.params.link != prevProps.match.params.link) {
            this.getArticle();
            this.addEmbedClick();
        }
    }

    getArticle() {
        this.props.actions.getArticle(this.props.match.params.link);
    }

    addEmbedClick() {
        $('#btn-shareexplainer').on('click', (e) => {
            e.preventDefault();
            $('#expsharebox .form-group').slideToggle(350);
        });
    }

    getTitle() {
        let title = '';
        if(this.props.article) {
            if(this.props.article.Title.indexOf('Infographic') == -1 && this.props.article.Title.indexOf('Ultimate Guide') == -1) {
                title += 'Blog Post - ';
            }
            title += `${this.props.article.Title} - LoudUp`;
        }        
        return title;
    }

    getImageShareUrl() {
        let imageShareUrl;
        if(this.props.article) {
            if(this.props.article.ImageUrl) {
                imageShareUrl = `${urls.USER_IMAGES_BASE_URL}${this.props.article.ImageUrl}`;
            }
            else {
                if(this.props.article.Title.indexOf('Infographic') > -1) {
                    const body = this.props.article.Paragraphs.join('');
                    const matches = body.match('<img.+?src=["\'](.+?)["\'].*?>');
                    imageShareUrl = matches[1];
                }
                else {
                    imageShareUrl = ShareService.getAbsoluteUrl(require('../../images/logo_loudup_mini.png'));
                }
            }
        }
        return imageShareUrl;
    }

    getMetaDescription() {
        return this.props.article ? this.props.article.Intro : '';
    }

    getArticleBody(article) {
        debugger;
        const content = [];
        //lists (ul or ol tag) can have nested paragraphs, and this can mess up the display as we end up rendering an incomplete list tag as we get the data by paragraph. Try to fix this by 
        //building an intermediary content string for lists until we have the full thing, and then render
        let listContent = '';
        let listTagBalancer = 0;
        let listTagOpened = null;
        for (let i = 0; i < article.Paragraphs.length; i++) {
            const paragraph = article.Paragraphs[i];
            if (paragraph.startsWith('<ul>') || paragraph.startsWith('<ol>') || listTagBalancer !== 0) {
                const openingTag = listTagOpened === '<ul>' || paragraph.startsWith('<ul>') ? '<ul>' : '<ol>';
                const closingTag = openingTag === '<ul>' ? '</ul>' : '</ol>';
                const openingTagCount = (paragraph.match(new RegExp(openingTag, "g")) || []).length;
                const closingTagCount = (paragraph.match(new RegExp(closingTag, "g")) || []).length;
                listTagBalancer += openingTagCount - closingTagCount;
                listContent += listContent ? `<p className="intro">${paragraph}</p>` : paragraph;
                if (listTagBalancer === 0) {
                    content.push(<span key={i} dangerouslySetInnerHTML={{ __html: listContent }} />);
                    listContent = '';
                    listTagOpened = null;
                }
                else {
                    listTagOpened = openingTag;
                }
            }
            else {
                content.push(<p key={i} className="intro" dangerouslySetInnerHTML={{ __html: paragraph }} />);
            }   
        }
        return content;
    }

    render() {
        const title = this.getTitle();
        const description = this.getMetaDescription();
        const url = ShareService.getAbsoluteUrl(this.props.match.url);
        const imageShareUrl = this.getImageShareUrl();
        const article = this.props.article;
        return (
            
            <div className="main blog">     
                <MetaTags>
                    <title>{title}</title>            
                    <meta id="description" name="description" content={description} />  
                    <meta id="og-url" property="og:url" content={url} />
                    <meta id="og-description" property="og:description" content={description} />
                    <meta id="og-image" property="og:image" content={imageShareUrl} />
                    <meta id="twitter-url" name="twitter:url" content={url} />
                    <meta id="twitter-title" name="twitter:title" content={title} />
                    <meta id="twitter-description" name="twitter:description" content={description} />
                    <meta id="twitter-image" name="twitter:image" content={imageShareUrl} />
                </MetaTags>
                <link href="https://fonts.googleapis.com/css?family=Indie+Flower" rel="stylesheet" type="text/css" />
                <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css" />
                <style>{`.attribution {font-size: 0.9em; font-style: italic;}`}</style>

                <div className="main blog">
                    <div className="container">
                        <div className="block-inner">
                            <div className="blog-content">
                            {
                                article ?
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div id="blogSummaryContainer">
                                                <div className="back">
                                                    <Link to={this.props.articleType === articleTypes.general ? '/Blog' : '/Unsigned'} className="btn-back transition">«- Return to {this.props.articleType === articleTypes.general ? 'Blog Listings' : 'Unsigned Guide'}</Link>
                                                </div>
                                                <div className="blogcol">
                                                    <article className="blogpost">
                                                        <header>
                                                            <h1>
                                                                <a href={null} className="transition">{article.Title}</a>
                                                            </h1>
                                                            <p className="spec">
                                                                <span className="sections">
                                                                {
                                                                    article.Sections.map(section =>
                                                                        <a key={section} href={null} className="sect transition">{section}</a>
                                                                    )
                                                                }
                                                                </span>
                                                                <em>By <Link to={`/${article.AuthorUsername}`}>{article.AuthorDisplayName}</Link></em>
                                                            </p>
                                                        </header>
                                                        <div className="blogbody">
                                                            {
                                                                article.ImageUrl && article.Title.indexOf('[Infographic]') == -1 ?
                                                                    <div className="blogimg">
                                                                            <img className="img-responsive" src={`${urls.USER_IMAGES_BASE_URL}${article.ImageUrl}?width=527&maxheight=420&quality=80&mode=crop&scale=both&format=jpg`} alt={article.Title} />                                                                        
                                                                    </div>
                                                                    : null
                                                            }
                                                            {this.getArticleBody(article)}
                                                            <br />
                                                        </div>
                                                        <ContentShare absoluteUrl={url} relativeUrl={this.props.match.url} shareCount={article.ShareCount} articleType={this.props.articleType} showMailingList showText />
                                                        <br />
                                                        {
                                                            article.Tags && article.Tags.length ?
                                                            <React.Fragment>
                                                                <br />
                                                                <div className="arttags">
                                                                    <svg className="icon icn-tag transition">
                                                                        <use xlinkHref="#icn-tag" />
                                                                    </svg>
                                                                    {
                                                                        article.Tags.map(tag =>
                                                                            <a key={tag} href={null} className="tag transition">{tag}</a>
                                                                        )
                                                                    }
                                                                </div>
                                                            </React.Fragment>
                                                            : null
                                                        }
                                                        <br />
                                                    </article>
                                                    {
                                                        article.RelatedPosts && article.RelatedPosts.length ?
                                                            <div className="blogrelated">
                                                                <h2>Related posts</h2>
                                                                {
                                                                    article.RelatedPosts.map(item =>
                                                                        <article key={item.Link} className="blogpost">
                                                                            <header className="transition">
                                                                                <div className="imgbox">
                                                                                    <a href={null}>
                                                                                    {
                                                                                        item.ImageUrl ?
                                                                                            <img src={`${urls.USER_IMAGES_BASE_URL}${item.ImageUrl}?width=100&aspectw=1.75&quality=80&mode=crop&scale=both&format=jpg`} alt={item.Title} />
                                                                                        :
                                                                                            <img src={require('../../images/relatedblog-blank.png')} alt={item.Title} />
                                                                                    
                                                                                    }
                                                                                    </a>
                                                                                </div>
                                                                                <h1>
                                                                                    <Link to={`/${this.props.articleType === articleTypes.general ? 'blog' : 'unsigned'}/${item.Link}`} className="transition">{item.Title}</Link>
                                                                                </h1>
                                                                                <p className="spec">
                                                                                    <span className="sections">
                                                                                    {
                                                                                        item.Sections.map(section =>
                                                                                            <a key={section} href={null} className="sect transition">{section}</a>
                                                                                        )
                                                                                    }
                                                                                    </span>
                                                                                    <br />
                                                                                    <span style={{fontSize: '0.9em'}}><em>{item.Intro}</em></span>
                                                                                </p>
                                                                            </header>
                                                                        </article>
                                                                    )
                                                                }
                                                            </div>
                                                            : null
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="content-side-2" style={{paddingTop: '40px'}}>
                                                <Advert adType="Square" />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    this.props.articleLoadingStatus && this.props.articleLoadingStatus.status == 'LOADING' ? <Loading />  : <NotFound />
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

ArticlePage.propTypes = {
    articleType: PropTypes.string.isRequired,
    article: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    articleLoadingStatus: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let articleType = '';
    const path = ownProps.match.path;
    if(startsWith(path, '/Blog')) {
        articleType = articleTypes.general;
    } 
    else if(startsWith(path, '/Unsigned')) {
        articleType = articleTypes.unsigned;
    } 
    else {
        articleType = articleTypes.discover;
    }
    let article = null;
    if(state.blog.article && state.blog.article.Link.toLowerCase() === ownProps.match.params.link.toLowerCase()) {
        article = state.blog.article;
    }
    return { articleType, article, articleLoadingStatus: state.blog.articleLoadingStatus };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, blogActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlePage);
